export const BILLING_STATUSES = {
  INACTIVE: 'inactive',
  INCOMPLETE: 'incomplete',
  PAID: 'paid',
  UNPAID: 'unpaid',
  PAST_DUE: 'past_due',
  TRIALING: 'trialing'
}

export const INNER_SIDER_WIDTH = '224px'

export const COLORS_PALETTE = [
  '#039BE5',
  '#7986CB',
  '#336679',
  '#8E24AA',
  '#E67C73',
  '#F6C026',
  '#F5511D',
  '#616161',
  '#3F51B5',
  '#068043',
  '#D60000'
]

export const FALLBACK_IMAGE = 'data:image/png;base64,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'

export const FORM_ITEM_LAYOUT_DEFAULT = {
  labelCol: {
    span: 2
  },
  wrapperCol: {
    span: 11
  }
}

export const ACCOUNT_MENU_ITEMS = [
  {
    key: 'profile',
    icon: 'SmileOutlined',
    component: 'ProfileSettings'
  },
  {
    key: 'security',
    icon: 'SafetyCertificateOutlined',
    component: 'SecuritySettings'
  },
  {
    key: 'notifications',
    icon: 'BellOutlined',
    component: 'NotificationsSettings'
  }
]

export const WORKSPACE_MENU_ITEMS = [
  {
    key: 'general',
    icon: 'SettingOutlined',
    component: 'GeneralSettings'
  },
  {
    key: 'subscription',
    icon: 'CreditCardOutlined',
    component: 'SubscriptionSettings'
  },
  {
    key: 'watermark',
    icon: 'EyeOutlined',
    component: 'WatermarkSettings'
  },
  {
    key: 'emergency',
    icon: 'NotificationOutlined',
    component: 'EmergencySettings'
  },
  {
    key: 'customBranding',
    icon: 'BgColorsOutlined',
    component: 'BrandingSettings'
  },
  {
    key: 'changeLogs',
    icon: 'OrderedListOutlined',
    component: 'ChangeLogs'
  },
  {
    key: 'apiKeys',
    icon: 'ApiOutlined',
    component: 'ExternalApiSettings'
  }
]


export const GENERAL_MENU_ITEMS = [
  {
    title: 'Account',
    key: 'account',
    items: [
      {
        key: 'profile',
        icon: 'SmileOutlined',
        component: 'ProfileSettings'
      },
      {
        key: 'security',
        icon: 'SafetyCertificateOutlined',
        component: 'SecuritySettings'
      },
      {
        key: 'notifications',
        icon: 'BellOutlined',
        component: 'NotificationsSettings'
      }
    ]
  },
  {
    title: 'Workspace',
    key: 'workspace',
    items: [
      {
        key: 'general',
        icon: 'SettingOutlined',
        component: 'GeneralSettings'
      },
      {
        key: 'subscription',
        icon: 'CreditCardOutlined',
        component: 'SubscriptionSettings'
      },
      {
        key: 'watermark',
        icon: 'EyeOutlined',
        component: 'WatermarkSettings'
      },
      {
        key: 'emergency',
        icon: 'NotificationOutlined',
        component: 'EmergencySettings'
      },
      {
        key: 'customBranding',
        icon: 'BgColorsOutlined',
        component: 'BrandingSettings'
      },
      {
        key: 'changeLogs',
        icon: 'OrderedListOutlined',
        component: 'ChangeLogs'
      }
    ]
  }
]

export const ZONING_LAYOUTS = [
  {
    type: 'V',
    name: 'No Zoning',
    key: 'noZoning',
    zones: 1,
    grid: 'grid-template-columns: 1fr; grid-template-rows: 1fr;',
    styles: {
      a: ''
    }
  },
  {
    type: 'VH',
    name: 'Two Zones',
    key: 'twoZones',
    zones: 2,
    grid: 'grid-template-columns: repeat(3, 1fr); grid-template-rows: repeat(2, 1fr)',
    styles: {
      a: 'grid-area: 1 / 1 / span 2 / span 2',
      b: 'grid-area: 1 / 3 / span 2'
    }
  },
  {
    type: 'VHH',
    name: 'Three Zones A',
    key: 'threeZonesA',
    zones: 3,
    grid: 'grid-template-columns: repeat(3, 1fr); grid-template-rows: repeat(2, 1fr)',
    styles: {
      a: 'grid-area: 1 / 1 / span 2 / span 2',
      b: 'grid-area: 1 / 3',
      c: 'grid-area: 2 / 3'
    }
  },
  {
    type: 'VVH',
    name: 'Three Zones B',
    key: 'threeZonesB',
    zones: 3,
    grid: 'grid-template-columns: repeat(3, 1fr); grid-template-rows: repeat(3, 1fr)',
    styles: {
      a: 'grid-area: 1 / 1 / span 2 / span 2',
      b: 'grid-area: 1 / 3 / span 2',
      c: 'grid-area: 3 / 1 / auto / span 3'
    }
  },
  {
    type: 'VHV',
    name: 'Three Zones C',
    key: 'threeZonesC',
    zones: 3,
    grid: 'grid-template-columns: repeat(3, 1fr); grid-template-rows: repeat(3, 1fr)',
    styles: {
      a: 'grid-area: 1 / 1 / span 2 / span 2',
      b: 'grid-area: 1 / 3 / span 3',
      c: 'grid-area: 3 / 1 / auto / span 2'
    }
  },
  {
    type: 'HHH',
    name: 'Three Zones D',
    key: 'threeZonesD',
    zones: 3,
    grid: 'grid-template-columns: repeat(3, 1fr); grid-template-rows: 1fr',
    styles: {
      a: 'grid-area: 1 / 2 / span 2',
      b: 'grid-area: 1 / 1 / span 2',
      c: 'grid-area: 1 / 3 / span 2'
    }
  }
]

export const ASPECT_RATIO_MAP = {
  'V': {
    'MAIN': '1:1'
  },
  'VH': {
    'MAIN': '2/3:1',
    'ZONE_A': '1/3:1'
  },
  'VHH': {
    'MAIN': '2/3:1',
    'ZONE_A': '1/3:1/2',
    'ZONE_B': '1/3:1/2'
  },
  'VVH': {
    'MAIN': '2/3:2/3',
    'ZONE_A': '1/3:2/3',
    'ZONE_B': '1:1/3'
  },
  'VHV': {
    'MAIN': '2/3:2/3',
    'ZONE_A': '1/3:1',
    'ZONE_B': '2/3:1/3'
  },
  'HHH': {
    'MAIN': '1/3:1',
    'ZONE_A': '1/3:1',
    'ZONE_B': '1/3:1'
  }
}

export const DEFAULT_ZONING_LAYOUT = ZONING_LAYOUTS[0].type

export const DEFAULT_PLAYLIST_COLOR = '#8E25AA'

export const DAY_IN_MILLISECONDS = 60 * 60 * 24 * 1000

export const EVENT_BASE = {
  eventId: null,
  playlistId: null,
  playlistName: null,
  timeFrom: null,
  timeTo: null,
  color: null,
  day: null,
  paused: null
}

export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export const LANGUAGES_LIST = [
  'UKRAINIAN',
  'ENGLISH_US',
  'GERMAN',
  'SPANISH',
  'FRENCH',
  'ITALIAN',
  'CHINESE',
  'PORTUGUESE',
  'JAPANESE',
  'NORWEGIAN'
]

export const GROUPS_LANGUAGES_LIST = [
  'UKRAINIAN',
  'ENGLISH_US',
  'GERMAN',
  'SPANISH',
  'FRENCH',
  'ITALIAN',
  'CHINESE',
  'DUTCH',
  'PORTUGUESE',
  'JAPANESE'
]

export const INDUSTRY_LIST = [
  "HEALTHCARE",
  "RETAIL",
  "FINANCE",
  "HOSPITALITY",
  "TECHNOLOGY",
  "REAL_ESTATE",
  "EDUCATION",
  "MANUFACTURING",
  "TRANSPORTATION_LOGISTICS",
  "MEDIA_ENTERTAINMENT",
  "NON_PROFIT",
  "GOVERNMENT",
  "OTHER"
]

export const COMPANY_SIZE_LIST = [
  "JUST_ME",
  "FROM_2_TO_5",
  "FROM_6_TO_20",
  "FROM_21_TO_50",
  "FROM_51_TO_100",
  "FROM_101_TO_500",
  "MORE_THAN_500"
]

export const DEVICES_NUMBER_MARKS = {
  0: '0',
  5: '5',
  10: '10',
  20: '20',
  30: '30',
  50: '50',
  100: '100'
}

export const BACKGROUND_EVENT_COLOR = '#e0e5e2'

export const SOCIALS = [
  {
    name: 'Instagram',
    icon: 'InstagramOutlined',
    type: 'instagram'
  },
  {
    name: 'Twitter',
    icon: 'TwitterOutlined',
    type: 'twitter'
  },
  {
    name: 'Google',
    icon: 'GoogleOutlined',
    type: 'google'
  },
  {
    name: 'Microsoft',
    icon: 'WindowsOutlined',
    type: 'microsoft'
  },
  {
    name: 'Dropbox',
    icon: 'DropboxOutlined',
    type: 'dropbox'
  },
  {
    name: 'Power BI',
    icon: 'BarChartOutlined',
    type: 'powerbi'
  }
]

export const MIME_TYPES_MAP = {
  DIRECTORY: 'DIRECTORY',
  'video/3gpp': 'VIDEO_3GPP',
  'video/mp4': 'VIDEO_MP4',
  'video/mpeg': 'VIDEO_MPEG',
  'video/ogg': 'VIDEO_OGG',
  'video/quicktime': 'VIDEO_QUICKTIME',
  'video/webm': 'VIDEO_WEBM',
  'video/avi': 'VIDEO_X_MSVIDEO',
  'video/x-m4v': 'VIDEO_X_M4V',
  'video/x-ms-asf': 'VIDEO_MS_ASF',
  'video/x-ms-wmv': 'VIDEO_X_MS_WMV',
  'video/x-msvideo': 'VIDEO_X_MSVIDEO',
  'image/apng': 'IMAGE_APNG',
  'image/avif': 'IMAGE_AVIF',
  'image/gif': 'IMAGE_GIF',
  'image/jpeg': 'IMAGE_JPEG',
  'image/png': 'IMAGE_PNG',
  'image/svg+xml': 'IMAGE_SVG_XML',
  'image/heic': 'IMAGE_HEIC',
  'image/webp': 'IMAGE_WEBP',
  'application/vnd.ms-powerpoint': 'DOCUMENT_PPT',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'DOCUMENT_PPTX',
  'application/vnd.oasis.opendocument.presentation': 'DOCUMENT_ODP',
  'application/pdf': 'DOCUMENT_PDF',
  'application/msword': 'DOCUMENT_DOC',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCUMENT_DOCX',
  'application/x-iwork-pages-sffpages': 'DOCUMENT_PAGES',
  'application/vnd.apple.keynote': 'DOCUMENT_KEYNOTE',
  'application/x-iwork-keynote-sffkey': 'DOCUMENT_KEYNOTE',
  '.pages': 'DOCUMENT_PAGES',
  '.heic': 'IMAGE_HEIC',
  '.key': 'DOCUMENT_KEYNOTE'
};

export const AUDIO_MIME_TYPES =  'audio/mpeg,audio/ogg,audio/wav,audio/webm,audio/x-wav,audio/flac,audio/aac,audio/mp4,audio/x-m4a,audio/x-ms-wma'

export const ACCEPTED_MIME_TYPES = {
  IMAGE: 'image/apng,image/avif,image/gif,image/jpeg,image/png,image/svg+xml,image/webp,image/heic',
  FAVICON: 'image/gif,image/jpeg,image/png,image/x-icon',
  DOCUMENT: 'application/vnd.google-apps.spreadsheet,application/vnd.google-apps.presentation,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.oasis.opendocument.presentation,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/x-iwork-pages-sffpages,application/vnd.apple.keynote,application/x-iwork-keynote-sffkey,.pages,.key,.gsheets,.gslides,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/vnd.oasis.opendocument.spreadsheet,text/csv,application/vnd.google-apps.document',
  VIDEO: 'video/3gpp,video/mp4,video/mpeg,video/ogg,video/quicktime,video/webm,video/x-m4v,video/x-ms-asf,video/x-ms-wmv,video/x-msvideo'
}

export const ALL_ACCEPTED_MIME_TYPES = Object.values(ACCEPTED_MIME_TYPES).join(',')

export const DEFAULT_ACCENT_COLOR = '#009E74'
export const DEFAULT_BORDER_RADIUS = 6

export const MAX_SOCIAL_ACCOUNTS_IN_SLIDE = 3

export const SESSION_TIME = 1000 * 60 * 5

export const TABLE_PAGE_LIMIT = 10

// export const PROTOCOL_REGEXP = /^(?:https?:\/\/)?(?:www\.)?/i
export const PROTOCOL_REGEXP = /^(https?|rtp|rtsp|rtmp|mms):\/\//i;
export const DEFAULT_PROTOCOL = 'https://'

export const MEDIA_TYPES_ENUM = {
  DIRECTORY: 'DIRECTORY',
  DOCUMENT: 'DOCUMENT',
  VIDEO: 'VIDEO',
  IMAGE: 'IMAGE'
}

export const MEDIA_TYPES =  Object.values(MEDIA_TYPES_ENUM)

export const LAYOUT_ZONE_KEYS_TO_INDEX = {
  'MAIN': 0,
  'ZONE_A': 1,
  'ZONE_B': 2
}

export const LAYOUT_ZONES_SETTINGS = [
  {
    name: 'Main Area',
    nameKey: 'main',
    key: 'MAIN',
    zoneKey: 'a'
  },
  {
    name: 'Area 1',
    nameKey: "area1",
    key: 'ZONE_A',
    zoneKey: 'b'
  },
  {
    name: 'Area 2',
    nameKey: "area2",
    key: 'ZONE_B',
    zoneKey: 'c'
  }
]

export const NEWS_CATEGORIES = [
  'technology',
  'lifestyle',
  'business',
  'general',
  'science',
  'entertainment',
  'world',
  'sports',
  'finance',
  'politics',
  'health',
  'food',
  'travel',
  'art',
  'music',
  'television',
  'movie',
  'entrepreneur',
  'gadgets',
  'design',
  'funny'
]

export const TIER_NAMES_MAP = {
  demo: 'Demo Mode',
  growth: "Kitcast Growth",
  enterprize: 'Kitcast Enterprise',
  null: 'Demo mode'
}
export const ROLE_NAMES_MAP = {
  ADMIN: 'Admin',
  OWNER: "Owner",
  MANAGER: 'Manager',
  AUTHOR: 'Author',
  CONTENT_MANAGER: 'Content Manager'
}

export const TRANSITIONS_NAMES_MAP = {
  PUSH_TO_LEFT: 'pushLeft',
  PUSH_BACK: 'pushBack',
  FLIP_LEFT: 'flipLeft',
  FLIP_BACK: 'flipBack',
  FADE: 'fade'
}

export const DEFAULT_TRANSITION = 'PUSH_BACK'

export const MUSIC_MOODS = [
  'Calm',
  'Energizing',
  'Joyful',
  'Sad',
  'Tense',
  'Beautiful',
  'Romantic',
  'Dreamy',
  'Heroic',
  'Scary'
]

export const LAYOUT_ALIGN_MAP = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
}

export const DEFAULT_TEMPLATE_FOREGROUND_COLOR = '#ffffff'

export const LOCALES_MAP = {
  ENGLISH_US: 'en',
  UKRAINIAN: 'ua',
  GERMAN: 'de',
  SPANISH: 'es',
  FRENCH: 'fr',
  ITALIAN: 'it',
  CHINESE: 'zh',
  PORTUGUESE: 'pt',
  JAPANESE: 'ja',
  DUTCH: 'nl',
  POLISH: 'pl',
  NORWEGIAN: 'no'
}

export const AVATARS = [
  'avatar_1.png',
  'avatar_2.png',
  'avatar_3.png',
  'avatar_4.png',
  'avatar_5.png',
  'avatar_6.png',
  'avatar_7.png',
  'avatar_8.png',
  'avatar_9.png',
  'avatar_10.png',
  'avatar_11.png',
  'avatar_12.png',
  'avatar_13.png',
  'avatar_14.png',
  'avatar_15.png',
  'avatar_16.png',
  'avatar_17.png',
  'avatar_18.png',
  'avatar_19.png',
  'avatar_20.png'
]

export const SMART_GROUP_TYPE = 'SMART'
export const STANDARD_GROUP_TYPE = 'STANDARD'

export const MAX_GROUPS_DEPTH = 4

export const AI_COLOUR_PALETTE = [
  {
    bgColor: DEFAULT_ACCENT_COLOR,
    color: "#ffffff"
  },
  {
    bgColor: "#8ecae6",
    color: "#000000"
  },
  {
    bgColor: "#219ebc",
    color: "#ffffff"
  },
  {
    bgColor: "#023047",
    color: "#ffffff"
  },
  {
    bgColor: "#ffb703",
    color: "#000000"
  },
  {
    bgColor: "#fb8500",
    color: "#ffffff"
  }
]

export const DEFAULT_DURATION_PER_SLIDE_ITEM = 6
export const DEFAULT_SLIDE_DURATION = 10

export const PAST_DUE_DAYS_LIMIT = 13

export const ROLES = {
  ADMIN: 'ADMIN',
  OWNER: 'OWNER',
  MANAGER: 'MANAGER',
  AUTHOR: 'AUTHOR'
}

export const MIN_DEVICES_FOR_GROWTH_PLAN = 1
export const MAX_DEVICES_FOR_GROWTH_PLAN = 10000

export const NAME_REGEXP = /^[\p{Letter}\p{Mark}\p{N}\-']+$/u
export const COMPANY_NAME_JOB_TITLE_REGEXP = /^[\p{Letter}\p{Mark}\p{N}\s\-',]+$/u

const _STATIC_ASSETS = {
  staging: {
    pineapple: {
      media: {
        "id": "a13f089a-df77-4dbb-8f29-1c4e493df760",
        "createdAt": "2025-01-15T09:18:41.847Z",
        "updatedAt": "2025-01-15T09:18:45.296Z",
        "name": "pineapple.png",
        "type": "UPLOADABLE_FILE",
        "autoDeleteOptions": null,
        "parentDirectoryMediaId": null,
        "authorIdentityId": "62fb9b36-0c16-4b81-8994-57ecd672a1c1",
        "__typename": "WorkspaceUploadableFileMediaModel",
        "processingData": [],
        "generatedMedia": [
          {
            "id": "c4d8f6d4-c525-43c8-b665-dda7ad02251d",
            "tag": "thumbnail",
            "url": "https://media.staging.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/a13f089a-df77-4dbb-8f29-1c4e493df760./18968911-61e3-4615-818c-1b46a352e7e8.generated.png",
            "__typename": "GeneratedMediaModel"
          },
          {
            "id": "9d4a1110-97a9-410d-ad5a-0cc00bacd99f",
            "tag": "preview",
            "url": "https://media.staging.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/a13f089a-df77-4dbb-8f29-1c4e493df760./6576010d-f66f-4c67-b854-6aba6c83787f.generated.png",
            "__typename": "GeneratedMediaModel"
          },
          {
            "id": "019e456d-1f45-4b37-bb42-dffcfe9e575d",
            "tag": "content",
            "url": "https://media.staging.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/a13f089a-df77-4dbb-8f29-1c4e493df760./fa31fc76-82bd-497b-a5c7-62bb21912fab.generated.png",
            "__typename": "GeneratedMediaModel"
          }
        ],
        "putObjectSignedUrl": null,
        "metadata": {
          "__typename": "MediaImageMetadata"
        },
        "path": "media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/a13f089a-df77-4dbb-8f29-1c4e493df760.png",
        "isUploaded": true,
        "size": 975046,
        "url": "https://media.staging.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/a13f089a-df77-4dbb-8f29-1c4e493df760.png",
        "mimetype": "IMAGE_PNG"
      },
      mediaReference: {
        sourceType: 'STATIC_MEDIA',
        staticMediaId: "678143b2-9a21-456c-a110-2b696da411f6"
      }
    },
    kitcastLogo:{
      media: {
        "id": "cfd74d1a-b48c-4631-8d45-d8622da25cef",
        "createdAt": "2025-01-15T10:22:32.852Z",
        "updatedAt": "2025-01-15T10:22:34.206Z",
        "name": "kitcast_logo.png",
        "type": "UPLOADABLE_FILE",
        "autoDeleteOptions": null,
        "parentDirectoryMediaId": null,
        "authorIdentityId": "62fb9b36-0c16-4b81-8994-57ecd672a1c1",
        "__typename": "WorkspaceUploadableFileMediaModel",
        "processingData": [],
        "generatedMedia": [
          {
            "id": "ca44799f-4145-42a9-ba57-4bbaea84d8b6",
            "tag": "preview",
            "url": "https://media.staging.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/cfd74d1a-b48c-4631-8d45-d8622da25cef./20e14075-cd76-49a9-bcf1-f314e5007309.generated.png",
            "__typename": "GeneratedMediaModel"
          },
          {
            "id": "b721b903-aca4-411a-a326-e98e1458069e",
            "tag": "thumbnail",
            "url": "https://media.staging.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/cfd74d1a-b48c-4631-8d45-d8622da25cef./5aa484aa-7646-498f-b080-2a102cb6a16d.generated.png",
            "__typename": "GeneratedMediaModel"
          },
          {
            "id": "88dcc017-409b-4262-83c6-0f68f0b1f40f",
            "tag": "content",
            "url": "https://media.staging.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/cfd74d1a-b48c-4631-8d45-d8622da25cef./7066226e-57b7-4a99-b42d-9dccc67c59fc.generated.png",
            "__typename": "GeneratedMediaModel"
          }
        ],
        "putObjectSignedUrl": null,
        "metadata": {
          "__typename": "MediaImageMetadata"
        },
        "path": "media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/cfd74d1a-b48c-4631-8d45-d8622da25cef.png",
        "isUploaded": true,
        "size": 2106,
        "url": "https://media.staging.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/cfd74d1a-b48c-4631-8d45-d8622da25cef.png",
        "mimetype": "IMAGE_PNG"
      },
      mediaReference: {
        sourceType: 'STATIC_MEDIA',
        staticMediaId: "ca12a4da-44e8-4c95-bc9e-489e6e30c628"
      }
    }
  },
  production: {
    pineapple: {
      media: {
        "id": "1925a1a8-9e61-4e9b-bab1-9046c65846aa",
        "createdAt": "2025-03-04T13:58:22.115Z",
        "updatedAt": "2025-03-04T13:58:25.484Z",
        "name": "pineapple.png",
        "type": "UPLOADABLE_FILE",
        "autoDeleteOptions": null,
        "parentDirectoryMediaId": null,
        "authorIdentityId": "62fb9b36-0c16-4b81-8994-57ecd672a1c1",
        "__typename": "WorkspaceUploadableFileMediaModel",
        "processingData": [],
        "generatedMedia": [
          {
            "id": "7f54f6be-609c-4989-ab28-17adafb11891",
            "tag": "content",
            "url": "https://media.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/1925a1a8-9e61-4e9b-bab1-9046c65846aa./a93d2f57-983b-4f79-8d98-0c580cced1a7.generated.png",
            "__typename": "GeneratedMediaModel"
          },
          {
            "id": "ec452ce5-69b4-40cf-afea-2a34b3749ed7",
            "tag": "thumbnail",
            "url": "https://media.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/1925a1a8-9e61-4e9b-bab1-9046c65846aa./7b3ed265-9410-47a6-95d2-802cad4ded0f.generated.png",
            "__typename": "GeneratedMediaModel"
          },
          {
            "id": "97aca091-9a9a-4bfe-8157-1e36f629f547",
            "tag": "preview",
            "url": "https://media.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/1925a1a8-9e61-4e9b-bab1-9046c65846aa./ed66c66b-6699-452a-bd37-da3020663eed.generated.png",
            "__typename": "GeneratedMediaModel"
          }
        ],
        "putObjectSignedUrl": null,
        "metadata": {
          "__typename": "MediaImageMetadata"
        },
        "path": "media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/1925a1a8-9e61-4e9b-bab1-9046c65846aa.png",
        "isUploaded": true,
        "size": 975046,
        "url": "https://media.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/1925a1a8-9e61-4e9b-bab1-9046c65846aa.png",
        "mimetype": "IMAGE_PNG"
      },
      mediaReference: {
        sourceType: 'STATIC_MEDIA',
        staticMediaId: "6fe9aae9-868b-4c9c-8818-58642aae0308"
      }
    },
    kitcastLogo:{
      media: {
        "id": "7aa549fe-0dba-49c5-9d48-c222d2e0ff0d",
        "createdAt": "2025-03-04T13:58:22.117Z",
        "updatedAt": "2025-03-04T13:58:23.204Z",
        "name": "kitcast_logo.png",
        "type": "UPLOADABLE_FILE",
        "autoDeleteOptions": null,
        "parentDirectoryMediaId": null,
        "authorIdentityId": "62fb9b36-0c16-4b81-8994-57ecd672a1c1",
        "__typename": "WorkspaceUploadableFileMediaModel",
        "processingData": [],
        "generatedMedia": [
          {
            "id": "b16c9398-af49-4ef8-a190-a5f44d12edc3",
            "tag": "thumbnail",
            "url": "https://media.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/7aa549fe-0dba-49c5-9d48-c222d2e0ff0d./70b0af98-8890-4535-a8c2-403d53e1527b.generated.png",
            "__typename": "GeneratedMediaModel"
          },
          {
            "id": "6182a35c-0042-4436-8141-2913c5725204",
            "tag": "content",
            "url": "https://media.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/7aa549fe-0dba-49c5-9d48-c222d2e0ff0d./90d15b71-6e6f-4ebd-855d-18fb4f79f3a3.generated.png",
            "__typename": "GeneratedMediaModel"
          },
          {
            "id": "00eaffd5-7535-4c9a-8131-aec290272f9c",
            "tag": "preview",
            "url": "https://media.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/7aa549fe-0dba-49c5-9d48-c222d2e0ff0d./957a6878-3068-43fb-a338-4fda9280263e.generated.png",
            "__typename": "GeneratedMediaModel"
          }
        ],
        "putObjectSignedUrl": null,
        "metadata": {
          "__typename": "MediaImageMetadata"
        },
        "path": "media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/7aa549fe-0dba-49c5-9d48-c222d2e0ff0d.png",
        "isUploaded": true,
        "size": 2106,
        "url": "https://media.next.kitcast.tv/media/d2c03f8c-d080-4047-9488-ec5af39a2cfd/7aa549fe-0dba-49c5-9d48-c222d2e0ff0d.png",
        "mimetype": "IMAGE_PNG"
      },
      mediaReference: {
        sourceType: 'STATIC_MEDIA',
        staticMediaId: "ddaca563-1ed9-4b87-835e-5b68199185db"
      }
    }
  }
}

export const STATIC_ASSETS = _STATIC_ASSETS[process.env.VUE_APP_ENV] || _STATIC_ASSETS.production
